import UserDeleteForm from "./user-delete-form";

export default UserDeleteForm;